import React from "react";
import "./ProjectGallery.scss";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

import Wrapper from "components/Wrapper";

const LeftArrow = ({ onClick }) => (
  <div className="LeftArrow" onClick={onClick} />
);

const RightArrow = ({ onClick }) => (
  <div className="RightArrow" onClick={onClick} />
);

const ProjectImage = ({ image }) => (
  <div className="ProjectImage" style={{ backgroundImage: `url(${image})` }} />
);

const settings = {
  infinite: false,
  speed: 600,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <RightArrow />,
  prevArrow: <LeftArrow />
};

const ProjectGallery = ({ images }) => (
  <div className="ProjectGallery">
    <div className="Title">
      <Wrapper width={1200} center>
        <h3>Gallery</h3>
      </Wrapper>
    </div>

    <Slider {...settings}>
      {images &&
        images.map((image, i) => {
          return <ProjectImage key={i} image={image.image} />;
        })}
    </Slider>
  </div>
);

export default ProjectGallery;
